import axios from "axios";

const getAuthHeader = () => {
    const token = sessionStorage.getItem('token');
    const header = {
        headers: { 
            Authorization: "Bearer " + token
     }
    };
    return header;
}

export const saveReferalDetail =async(data)=>{
    const url=`${process.env.REACT_APP_API_URL}/api/insert-student-referal-detail`
    return axios.post(url,data,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const getReferalDetail =async()=>{
    const url=`${process.env.REACT_APP_API_URL}/api/get-student-referal-detail`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })
}